import useApi from "../../../Utils/BackendClient";
import { useFormik } from "formik";

import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";

import CheckboxInput from "../Inputs/CheckboxInput";
import { DisplayErrors } from "../../../Utils/ErrorHandler";
import TextInput from "../Inputs/TextInput";

import commonStyle from "../../content/CommonStyles.module.css";

const BrandCreationSidebar = ( {visible, onHide, toast, ctx, additionalActions} ) => {

    const { createBrandDictionary } = useApi(); 

    const formik = useFormik({
        initialValues: {
            name: "",
            is_active: true
        },
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (!values.name) {
                errors.name = "Введіть назву бренду"
            }

            return errors;
        },
        onSubmit: async (values) => {

            const response = await createBrandDictionary(values);

            if (response.status === 201) {
                toast.current.show({ severity: "success", summary: "Успіх", detail: `Бренд успішно створено`, life: 3000 });

                ctx.resetEnum("brands_dictionary");

                onHide();

                additionalActions(response.data.id);
            }
            else {
                DisplayErrors(response.error, toast);
            }
        }
    });

    return (
        <Sidebar visible={visible} position="right" className={commonStyle.sidebar} onHide={onHide} header={<h3>Меню додавання бренду</h3>}>
            <form onSubmit={formik.handleSubmit}>
                <TextInput formik={formik} paramName={"name"} label={"Назва бренду"} mandatory customStyle="w-full" />
                <CheckboxInput formik={formik} paramName={"is_active"} label={"Активний"} />
                <Button label="Додати" severity="success" type="submit" className={`${commonStyle.sideBarButton} ${commonStyle.addButton}`} autoFocus />
            </form>
        </Sidebar>
    )
}

export default BrandCreationSidebar;